/**
 * Footer – erscheint auf allen Seiten.
 * Pflichtlinks: Impressum, Datenschutz, AGB + Satirischer Disclaimer + Altershinweis.
 *
 * Einziger Footer der App (auf Dashboard-Seiten per body:has(#dashboard-root)
 * #nt-footer in layout.css ausgeblendet, dort übernimmt der inline
 * .dash-main-footer-* Footer aus dashboard.ts). Seiten wie die Landingpage
 * (home.ts) dürfen KEINEN eigenen zweiten Footer rendern – das führte bereits
 * einmal zu einer sichtbaren Dopplung.
 */

/** Footer-HTML erzeugen und an body anhängen. */
export function renderFooter(): void {
  // Kein doppelter Footer
  if (document.getElementById('nt-footer')) return;

  const footer = document.createElement('footer');
  footer.id = 'nt-footer';

  footer.innerHTML = `
    <nav class="footer-links" aria-label="Rechtliche Links">
      <a href="/impressum">Impressum</a>
      <span class="footer-sep">■</span>
      <a href="/datenschutz">Datenschutz</a>
      <span class="footer-sep">■</span>
      <a href="/agb">AGB</a>
    </nav>
    <p class="footer-disclaimer">
      nighttrade ist ein fiktives Spiel. Alle dargestellten Aktivitäten sind satirisch.
    </p>
    <p class="footer-age-notice">
      Nighttrade richtet sich ausschließlich an Personen ab 18 Jahren.
    </p>
  `;

  document.body.appendChild(footer);
}
